import { render, staticRenderFns } from "./sale_detail.vue?vue&type=template&id=bedf9094&scoped=true&"
import script from "./sale_detail.vue?vue&type=script&lang=js&"
export * from "./sale_detail.vue?vue&type=script&lang=js&"
import style0 from "./sale_detail.vue?vue&type=style&index=0&id=bedf9094&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedf9094",
  null
  
)

export default component.exports